import { first, map, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PreferencesService } from '../services/preferences.service';
import { Subject } from 'rxjs';
import { PreferenceMessages } from '../../../shared/models/component-messages/preference-messages';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InformationComponent } from '../../../shared/modals/information/information.component';
import { EnumMicroDroits } from '../../../administration/models/micro.droits';
import { AuthorizationService } from '../../../../authorization/services/authorization.service';

@Component({
  selector: 'app-preferences-logo',
  templateUrl: './preferences-logo.component.html',
  styleUrls: ['./preferences-logo.component.scss']
})
export class PreferencesLogoComponent implements OnInit, OnDestroy {

  private unsubscribe$ = new Subject<void>();

  public preferenceMessages = new PreferenceMessages();

  imageToShow: any;
  imageName: string = "";
  imageFound: boolean = false;
  errorBigImage: boolean = false;
  errorBadFormat: boolean = false;
  isGestionComptesAnnonceur: boolean;

  constructor(private preferenceService: PreferencesService, private modalService: NgbModal, private authorizationService: AuthorizationService) { }

  ngOnInit(): void {
    this.getLogo();
    this.habilitations();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  envoiFichier(fichiers: FileList): void {
    if (fichiers.length > 0) {
      if (fichiers.item(0).type == "image/png" || fichiers.item(0).type == "image/jpeg" || fichiers.item(0).type == "image/bmp" || fichiers.item(0).type == "image/jpg") {
        this.errorBadFormat = false;
        if (fichiers.item(0).size > 50000) {
          this.errorBigImage = true;
        } else {
          this.errorBigImage = false;
          const fileSelected = fichiers.item(0);
          this.preferenceService.createLogo(fileSelected).pipe(takeUntil(this.unsubscribe$))
            .subscribe({
              next: (() => {
                this.getLogo();
              })
            });
        }
      } else {
        this.errorBadFormat = true;
      }
    }
  }

  getLogo(): void {
    this.preferenceService.getLogoFull().pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          let reader = new FileReader();
          reader.addEventListener("load", () => {
            this.imageToShow = reader.result;
            if (this.imageToShow === "data:application/octet-stream;base64,") {
              this.imageFound = false;
            } else {
              this.imageFound = true;
              if (data.length > 0) {
                this.imageName = data[0].titre;
              }
            }
          }, false);

          if (data.length > 0) {
            reader.readAsDataURL(this.b64toBlob(data[0].logo, data[0].content.values.find(item => item.code === 'type').value));
          } else {
            reader.readAsDataURL(new Blob());
          }
        })
      });
  }

  private b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  delete(): void {

    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.content = this.preferenceMessages.modal_delete_text;
    modalRef.componentInstance.OkOuRetour = true;
    modalRef.dismissed.pipe(map((reason: boolean) => {
      return reason;
    }))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((reason) => {
          if (reason) {
            this.errorBigImage = false;
            this.errorBadFormat = false;
            this.preferenceService.deleteLogo().pipe(takeUntil(this.unsubscribe$))
              .subscribe({
                next: (() => {
                  this.getLogo();
                })
              });
          }
        })
      })
  }
  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn([EnumMicroDroits.COMPTES_ANNONCEURS_GESTION])
      .pipe(first())
      .subscribe(isGestionComptesAnnonceur => { this.isGestionComptesAnnonceur = isGestionComptesAnnonceur });
  }

}
